import React from 'react'
import './index.scss'
import {connect} from 'react-redux'
import sdkImg from '@/assets/images/sdk.png'
const mapStateToProps = (state) => ({
    tenant : state.getIn(['tenantReducer','tenant'])
  })
const SdkState = (props) => {
    let company = props.tenant;
    return (
        <div className="sdk-box__state">
            <div>
                <h2>{company}接入第三方SDK说明</h2>
                <p>为保障{company}APP相关功能的实现与应用的稳定运行，我们可能会接入由第三方提供的软件开发包（SDK）以实现相关目的。不同版本的第三方SDK会有所不同，一般包括推送服务类、导航定位类、自助报警类等。以下第三方SDK所收集的信息和保护规则在隐私协议正文中所有说明。
</p>
                <img src={sdkImg} alt="" />
                {/* <table>
                    <tr>
                        <td>功能类型</td>
                        <td>SDK名称</td>
                        <td>使用目的</td>
                        <td>第三方名称</td>
                        <td>收集的个人信息种类</td>
                        <td>官网链接</td>
                    </tr>
                    <tr>
                        <td>推送服务</td>
                        <td>极光推送</td>
                        <td>提供推送技术服务</td>
                        <td>深圳市和讯华谷信息技术有限公司</td>
                        <td>设备标识信息，应用列表</td>
                        <td>https://www.jiguang.cn/push?source=bdpc&plan=1&unit=18&keyword=244</td>
                    </tr>
                    <tr>
                        <td>语音技术</td>
                        <td>百度语音合成</td>
                        <td>语音播报</td>
                        <td>百度智能云语音技术</td>
                        <td>设备标识信息</td>
                        <td>https://cloud.baidu.com</td>
                    </tr>
                    <tr>
                        <td>人脸识别</td>
                        <td>百度离线采集</td>
                        <td>人脸识别</td>
                        <td>百度智能云人工智能-人脸识别</td>
                        <td>设备标识信息，面部识别，身份证号，姓名</td>
                        <td>https://cloud.baidu.com/product/face</td>
                    </tr>
                    <tr>
                        <td>定位导航服务</td>
                        <td>高德地图SDK</td>
                        <td>定位服务</td>
                        <td>阿里巴巴旗下高德开放平台</td>
                        <td>设备标识信息，设备定位信息</td>
                        <td>https://lbs.amap.com/api/android-sdk/summary/</td>
                    </tr>
                    <tr>
                        <td>APP异常采集</td>
                        <td>Bugly</td>
                        <td>统计APP异常上报</td>
                        <td>腾讯Bugly</td>
                        <td>设备标识信息，APP运行过程中的异常崩溃记录</td>
                        <td>https://bugly.qq.com/v2/</td>
                    </tr>
                </table> */}
            </div>
        </div>
    )
}
export default connect(mapStateToProps)(SdkState)